import PropTypes from 'prop-types';
import ToolbarContainer from '../toolbar/toolbarContainer';
import ViewerLoaderContainer from '../viewerLoader/viewerLoaderContainer';
import ZoomContainer from '../zoom/zoomContainer';
import FitAndRotateContainer from '../fitAndRotate/fitAndRotateContainer';
import AppDidUpdateContainer from '../appDidUpdate/appDidUpdateContainer';
import SidebarContainer from '../sidebar/sidebarContainer';
import ViewerOverlayContainer from '../viewerOverlay/viewerOverlayContainer';
import { TOOL_BAR_HEIGHT, DEFAULT_CLIENT_HEIGHT } from '../../constants';

export default function HomePage({ clientSize, sidePanelOpen, sidePanelWidth }) {
  const { height, width } = clientSize;
  const homePageStyles = { height: height - TOOL_BAR_HEIGHT, width };

  if (sidePanelOpen) {
    homePageStyles.width -= sidePanelWidth;
  }
  return (
    <div className="grid">
      <div className="row">
        <div
          id="reader-homepage"
          className="reader-homepage u-hide-from-print container"
          style={homePageStyles}
        >
          <div className="col-sm-24">
            <ToolbarContainer />
            <ZoomContainer />
            <FitAndRotateContainer />
            <ViewerLoaderContainer />
            <AppDidUpdateContainer />
          </div>
        </div>
        <ViewerOverlayContainer />
        <SidebarContainer />
      </div>
    </div>
  );
}

HomePage.propTypes = {
  clientSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  sidePanelOpen: PropTypes.bool,
  sidePanelWidth: PropTypes.number.isRequired,
};

HomePage.defaultProps = {
  clientSize: {
    height: DEFAULT_CLIENT_HEIGHT,
    width: 0,
  },
  sidePanelOpen: false,
};
